module.exports = __webpack_public_path__ + "static/media/iconYoutubeColor.fa90090f.svg";